import { getApiActionCreator } from 'helpers/actionHelper';
import { apiCallStatus, NOTIFICATION_TYPES } from 'helpers/constants';
import { ComponentApi, ReportApi } from 'api';
import { notify } from 'sharedComponents/GeneralNotification';
import { translate } from 'helpers/translateHelper';

import { actionTypes } from '../constants';
// import { getAssetsForReportType } from './selectors';
// import { getFilterForReportType } from './helpers';
import { loadReports, refreshDateFilters } from '../actions';

const isDateRangeError = (error) => {
    const errorMessage = error?.message?.toLowerCase() || error?.response?.data?.message?.toLowerCase() || '';
    return errorMessage.includes('date') && (errorMessage.includes('range') || errorMessage.includes('days'));
};

const showDateRangeErrorNotification = () => {
    notify(translate('ABB.Powertrain.Frontend.reportDateRangeApiError'), NOTIFICATION_TYPES.ERROR, true);
};


// const getCapabilitiesAction = getApiActionCreator(actionTypes.GET_CAPABILITIES);
const generateReportAction = getApiActionCreator(actionTypes.GENERATE_REPORT);
const generateFleetReportAction = getApiActionCreator(actionTypes.GENERATE_FLEET_REPORT);
const generateFleetDetailedReportAction = getApiActionCreator(actionTypes.GENERATE_FLEET_DETAILED_REPORT);
const getSensorOfAssetsAction = getApiActionCreator(actionTypes.GET_SENSOR_OF_ASSETS);
const getRawDataCollections = getApiActionCreator(actionTypes.GET_RAW_DATA_COLLECTIONS);

export const closeGeneratorModal = () => (dispatch) => dispatch({ type: actionTypes.CLOSE_GENERATOR_MODAL });
export const clearReportGeneration = () => (dispatch) => dispatch({ type: actionTypes.CLEAR_REPORT_GENERATION });

export const generateReport = (reportType, asset, unit, rawDataTimestamp, reportingPeriod) => {
    return async (dispatch, getState) => {
        dispatch(generateReportAction(apiCallStatus.LOADING));
        return await ReportApi.generateReport(reportType.reportTypeId, asset.id.toString(), unit.value, rawDataTimestamp, reportingPeriod)
            .then(() => {
                const isFromAssetDetails = !!getState().reports?.reportGenerator?.preselectedAsset;
                const messageKey = isFromAssetDetails
                    ? 'ABB.Powertrain.Frontend.reportGenerationInProgressMessage'
                    : 'ABB.Powertrain.Frontend.reportGenerationInProgressMessageShort';
                notify(translate(messageKey), NOTIFICATION_TYPES.INFO, false, 5000);
                dispatch(generateReportAction(apiCallStatus.SUCCESS));
                dispatch(loadReports());
                dispatch(refreshDateFilters());
            })
            .catch((err) => {
                dispatch(generateReportAction(apiCallStatus.ERROR, null, err));
                if (isDateRangeError(err)) {
                    showDateRangeErrorNotification();
                }
                throw err;
            });
    };
};


export const setReportTypeInRedux = (reportType) => (dispatch) => dispatch({ type: actionTypes.SET_REPORT_GENERATION_TYPE, reportType });

export const generateFleetReport = (reportType, reportingPeriod, unit) => {
    return async (dispatch, getState) => {
        dispatch(generateFleetReportAction(apiCallStatus.LOADING));
        const organization = getState().generalFilter?.selectedFilters?.organizations[0];

        const generateFleetReportParams = {
            reportTypeIdentifier: reportType.reportTypeId,
            organizationIdentifier: organization.organizationID.toString(),
            measurementUnit: unit.value,
            reportStartDate: reportingPeriod.from,
            reportEndDate: reportingPeriod.to
        };
        return await ReportApi.generateFleetReport(generateFleetReportParams)
            .then(() => {
                notify(translate('ABB.Powertrain.Frontend.reportGenerationInProgressMessageShort'), NOTIFICATION_TYPES.INFO, false, 5000);
                dispatch(generateFleetReportAction(apiCallStatus.SUCCESS));
                dispatch(loadReports());
                dispatch(refreshDateFilters());
            })
            .catch((err) => {
                dispatch(generateFleetReportAction(apiCallStatus.ERROR, null, err));
                if (isDateRangeError(err)) {
                    showDateRangeErrorNotification();
                }
                throw err;
            });
    };
};

export const generateFleetDetailedReport = (reportType, reportingPeriod, assetIds, unit) => {
    return async (dispatch, getState) => {
        dispatch(generateFleetDetailedReportAction(apiCallStatus.LOADING));
        const organization = getState().generalFilter?.selectedFilters?.organizations[0];
        const generateFleetReportParams = {
            reportTypeIdentifier: reportType.reportTypeId,
            organizationIdentifier: organization.organizationID.toString(),
            measurementUnit: unit.value,
            reportStartDate: reportingPeriod.from,
            reportEndDate: reportingPeriod.to,
            assetIds,
        };
        return await ReportApi.generateFleetReport(generateFleetReportParams)
            .then(() => {
                notify(translate('ABB.Powertrain.Frontend.reportGenerationInProgressMessageShort'), NOTIFICATION_TYPES.INFO, false, 5000);
                dispatch(generateFleetDetailedReportAction(apiCallStatus.SUCCESS));
                dispatch(loadReports());
                dispatch(refreshDateFilters());
            })
            .catch((err) => {
                dispatch(generateFleetDetailedReportAction(apiCallStatus.ERROR, null, err));
                if (isDateRangeError(err)) {
                    showDateRangeErrorNotification();
                }
                throw err;
            });
    };
};

export const getSensorOfAssets = () => {
    return async (dispatch, getState) => {
        dispatch(getSensorOfAssetsAction(apiCallStatus.LOADING));
        const assetIds = getState().overview?.assets?.data?.map(asset => asset.id);
        return await ComponentApi.getSensorOfAssets(assetIds)
            .then((data) => {
                dispatch(getSensorOfAssetsAction(apiCallStatus.SUCCESS, data));
            })
            .catch((err) => {
                dispatch(getSensorOfAssetsAction(apiCallStatus.ERROR, null, err));
            });
    };
};


export const clearRawDataCollections = () => (dispatch) => dispatch({ type: actionTypes.CLEAR_RAW_DATA_COLLECTIONS });

export const getRawDataCollectionTimestamps = (selectedAsset, startTime, endTime) => {
    return async (dispatch) => {
        dispatch(getRawDataCollections(apiCallStatus.LOADING));
        return await ReportApi.getRawDataCollections(selectedAsset?.id, startTime, endTime)
            .then((data) => {
                dispatch(getRawDataCollections(apiCallStatus.SUCCESS, data));
            })
            .catch((err) => {
                dispatch(getRawDataCollections(apiCallStatus.ERROR, null, err));
            });
    };
};
